var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-layout"},[_c('router-view'),_c('div',{staticClass:"footer-wrapper"},[_c('div',{staticClass:"container"},[_c('FooterCopyright'),_c('CheckSiteVersionLite',{on:{"disableLogin":_vm.onDisableLogin}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }